document.addEventListener('DOMContentLoaded', function() {
  initDenimFitGuideScrollspy();
});

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('[data-denim-fit-guide]')) {
    initDenimFitGuideScrollspy(event.target);
  }
});

document.addEventListener('shopify:block:select', function(event) {
  var section = event.target.closest('[data-denim-fit-section]');

  if (!section) {
    return;
  }

  var guide = section.closest('[data-denim-fit-guide]');

  markDenimFitGuideImageBlocks(guide);
  setDenimFitGuideActiveTarget(guide, getDenimFitGuideGroupTargetId(guide, section));
});

function initDenimFitGuideScrollspy(scope) {
  var container = scope || document;
  var guides = container.querySelectorAll('[data-denim-fit-guide]');

  guides.forEach(function(guide) {
    if (guide.getAttribute('data-denim-fit-guide-initialized') === 'true') {
      return;
    }

    guide.setAttribute('data-denim-fit-guide-initialized', 'true');
    markDenimFitGuideImageBlocks(guide);
    buildDenimFitGuideNav(guide);
    setupDenimFitGuideObserver(guide);

    guide.addEventListener('click', function(event) {
      var link = event.target.closest('[data-denim-fit-link]');

      if (!link) {
        return;
      }

      event.preventDefault();
      scrollToDenimFitGuideTarget(guide, link.getAttribute('data-denim-fit-target'));
    });

    window.addEventListener('resize', function() {
      setupDenimFitGuideObserver(guide);
    });

    guide.classList.add('is-initialized');
  });
}

function markDenimFitGuideImageBlocks(guide) {
  if (!guide) {
    return;
  }

  var imageGroups = guide.querySelectorAll('.denim-fit-guide-product__images');

  imageGroups.forEach(function(imageGroup) {
    var images = imageGroup.querySelectorAll('.denim-fit-guide-image');
    var hasDoubleWidthImage = false;

    images.forEach(function(image) {
      var wrapper = image.parentElement;
      var isDoubleWidth = image.classList.contains('denim-fit-guide-image--double-width');

      if (!wrapper || !wrapper.classList.contains('shopify-block')) {
        return;
      }

      image.classList.remove('denim-fit-guide-image--single-width');
      wrapper.classList.remove('denim-fit-guide-image-block--double-width');
      wrapper.classList.remove('denim-fit-guide-image-block--single-width');
      wrapper.classList.add('denim-fit-guide-image-block');

      if (!isDoubleWidth) {
        return;
      }

      if (hasDoubleWidthImage) {
        image.classList.add('denim-fit-guide-image--single-width');
        wrapper.classList.add('denim-fit-guide-image-block--single-width');
        return;
      }

      hasDoubleWidthImage = true;
      wrapper.classList.add('denim-fit-guide-image-block--double-width');
    });
  });
}

function buildDenimFitGuideNav(guide) {
  var nav = guide.querySelector('[data-denim-fit-nav]');
  var navList = nav ? nav.querySelector('.denim-fit-guide__subnav-list') : null;
  var sections = guide.querySelectorAll('[data-denim-fit-section]');
  var previousFit = null;
  var firstTargetId = null;

  if (!nav || !navList || !sections.length) {
    return;
  }

  navList.innerHTML = '';

  sections.forEach(function(section) {
    var fit = section.getAttribute('data-fit');

    if (!fit || fit === previousFit) {
      return;
    }

    previousFit = fit;
    firstTargetId = firstTargetId || section.id;
    navList.appendChild(createDenimFitGuideNavItem(fit, section.getAttribute('data-fit-label') || fit, section.id));
  });

  if (firstTargetId) {
    setDenimFitGuideActiveTarget(guide, firstTargetId);
  }
}

function createDenimFitGuideNavItem(fit, label, targetId) {
  var item = document.createElement('li');
  var link = document.createElement('a');

  item.className = 'denim-fit-guide__subnav-item';
  link.className = 'denim-fit-guide__subnav-link';
  link.href = targetId ? '#' + targetId : '#';
  link.setAttribute('data-denim-fit-link', fit);
  link.setAttribute('data-denim-fit-target', targetId);
  link.textContent = label;
  item.appendChild(link);

  return item;
}

function scrollToDenimFitGuideTarget(guide, targetId) {
  if (!guide || !targetId) {
    return;
  }

  var target = document.getElementById(targetId);

  if (!target || !guide.contains(target)) {
    return;
  }

  lockDenimFitGuideActiveTargetDuringScroll(guide, targetId);
  setDenimFitGuideActiveTarget(guide, targetId);

  window.scrollTo({
    top: target.getBoundingClientRect().top + window.pageYOffset - getDenimFitGuideScrollOffset(guide),
    behavior: 'smooth'
  });
}

function setupDenimFitGuideObserver(guide) {
  var sections = guide.querySelectorAll('[data-denim-fit-section]');

  if (guide.denimFitGuideObserver) {
    guide.denimFitGuideObserver.disconnect();
  }

  if (!sections.length || !('IntersectionObserver' in window)) {
    return;
  }

  guide.denimFitGuideObserver = new IntersectionObserver(function(entries) {
    var visibleEntry = null;

    entries.forEach(function(entry) {
      if (!entry.isIntersecting) {
        return;
      }

      if (!visibleEntry || entry.boundingClientRect.top < visibleEntry.boundingClientRect.top) {
        visibleEntry = entry;
      }
    });

    if (visibleEntry) {
      var visibleTargetId = getDenimFitGuideGroupTargetId(guide, visibleEntry.target);

      if (guide.denimFitGuideScrollLockedTarget && guide.denimFitGuideScrollLockedTarget !== visibleTargetId) {
        return;
      }

      setDenimFitGuideActiveTarget(guide, visibleTargetId);
    }
  }, {
    rootMargin: '-' + getDenimFitGuideScrollOffset(guide) + 'px 0px -60% 0px',
    threshold: 0
  });

  sections.forEach(function(section) {
    guide.denimFitGuideObserver.observe(section);
  });
}

function lockDenimFitGuideActiveTargetDuringScroll(guide, targetId) {
  if (!guide || !targetId) {
    return;
  }

  if (guide.denimFitGuideScrollUnlock) {
    guide.denimFitGuideScrollUnlock();
  }

  guide.denimFitGuideScrollLockedTarget = targetId;

  var scrollEndTimeout = null;
  var maxLockTimeout = null;

  var unlock = function() {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('scrollend', unlock);
    clearTimeout(scrollEndTimeout);
    clearTimeout(maxLockTimeout);
    guide.denimFitGuideScrollLockedTarget = null;
    guide.denimFitGuideScrollUnlock = null;
  };

  var onScroll = function() {
    clearTimeout(scrollEndTimeout);
    scrollEndTimeout = setTimeout(unlock, 150);
  };

  guide.denimFitGuideScrollUnlock = unlock;
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scrollend', unlock);
  maxLockTimeout = setTimeout(unlock, 4000);
}

function setDenimFitGuideActiveTarget(guide, targetId) {
  if (!guide || !targetId) {
    return;
  }

  var links = guide.querySelectorAll('[data-denim-fit-link]');

  links.forEach(function(link) {
    var isActive = link.getAttribute('data-denim-fit-target') === targetId;

    link.classList.toggle('is-active', isActive);

    if (isActive) {
      link.setAttribute('aria-current', 'true');
    } else {
      link.removeAttribute('aria-current');
    }
  });
}

function getDenimFitGuideGroupTargetId(guide, section) {
  if (!guide || !section) {
    return null;
  }

  var sections = Array.prototype.slice.call(guide.querySelectorAll('[data-denim-fit-section]'));
  var sectionIndex = sections.indexOf(section);
  var fit = section.getAttribute('data-fit');

  if (sectionIndex === -1 || !fit) {
    return null;
  }

  while (sectionIndex > 0 && sections[sectionIndex - 1].getAttribute('data-fit') === fit) {
    sectionIndex -= 1;
  }

  return sections[sectionIndex].id;
}

function getDenimFitGuideHeaderHeight() {
  var header = document.getElementById('header-container');

  return header ? header.getBoundingClientRect().height : 0;
}

function getDenimFitGuideScrollOffset(guide) {
  return getDenimFitGuideHeaderHeight();
}
